var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items && _vm.items.length
    ? _c("div", { staticClass: "slider" }, [
        _c("div", { staticClass: "slider__container" }, [
          _vm.title || _vm.arrows
            ? _c("div", { staticClass: "slider__header" }, [
                _c(
                  "div",
                  { staticClass: "slider__header--right" },
                  [
                    _c("h2", [_vm._v(_vm._s(_vm.title))]),
                    (_vm.swiper && !_vm.hideArrows) || _vm.arrows
                      ? _c("SliderArrowsComponent", {
                          on: {
                            left: function ($event) {
                              return _vm.swiper.slidePrev()
                            },
                            right: function ($event) {
                              return _vm.swiper.slideNext()
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "slider__items" }, [
            _c("div", { ref: "items", staticClass: "swiper" }, [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.items, function (item, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "swiper-slide" },
                    [_vm._t("default", null, { i: i, item: item })],
                    2
                  )
                }),
                0
              ),
              _vm.sliderOptions.pagination
                ? _c("div", {
                    ref: "pagination",
                    staticClass: "swiper-pagination",
                  })
                : _vm._e(),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }